import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { selectFormatAmount } from 'app/modules/orgSettings/selectors';
import {
  U21Card,
  U21Chip,
  U21Loading,
  U21ShowMoreList,
  U21Typography,
} from 'app/shared/u21-ui/components';
import styled from 'styled-components';
import pluralize from 'pluralize';

interface EntityToAggregateCardProps {
  title: string;
  data: { name: string; value: number; count: number }[];
  isLoading: boolean;
}

export const EntityToAggregateCard = (props: EntityToAggregateCardProps) => {
  const { title, data, isLoading } = props;
  const formatAmount = useSelector(selectFormatAmount);

  const { sortedData, totalAmountSum } = useMemo(() => {
    const sorted = data.toSorted((a, b) => b.value - a.value);
    const total = data.reduce((acc, item) => acc + item.value, 0);
    return { sortedData: sorted, totalAmountSum: total };
  }, [data]);

  return (
    <U21Card title={title}>
      {isLoading ? (
        <U21Loading loading label="" />
      ) : (
        <U21ShowMoreList
          displayFunc={(item) => (
            <StyledChip key={item.name}>
              <U21Typography variant="subtitle2">{item.name}:</U21Typography>
              <U21Typography variant="body2">
                {item.count} {pluralize('transaction', item.count)}
              </U21Typography>
              <U21Typography variant="body2">
                {formatAmount({ amount: item.value })} (
                {new Intl.NumberFormat('en-US', {
                  maximumFractionDigits: 2,
                  style: 'percent',
                }).format(item.value / totalAmountSum)}
                )
              </U21Typography>
            </StyledChip>
          )}
          horizontal
          limit={3}
          value={sortedData}
        />
      )}
    </U21Card>
  );
};

const StyledChip = styled(U21Chip)`
  height: unset;
`;
